export const HEADLINE = 'Nächste Station: Vorstellungsgespräch';

export const TEXT_CONTENT =
  'Glückwunsch, Du und Deine Bewerbung scheinen überzeugt zu haben! Jetzt geht es zum Vorstellungsgespräch. Du hast dazu bestimmt jetzt viele Fragen. Auf die häufigsten versuchen wir hier einmal eine Antwort zu geben:';

export const ACCORDION_DATA = [
  {
    question: 'Wie bereite ich mich auf ein Vostellungsgspräch vor?',
    answer:
      'Die Vorbereitung auf ein Vorstellungsgespräch ist entscheidend. Recherchiere das Unternehmen und die Position gründlich. Bereite Antworten auf häufige Fragen vor und über Deine Selbstpräsentation. Pünktlichkeit und angemessene Kleidung sind ebenfalls wichtig. Zeige Engagement und Begeisterung für Deinen Traumjob.',
  },
  {
    question: 'Welcher Dresscode gilt für ein Bewerbungsgespräch',
    answer:
      'Für ein Vorstellungsgespräch gilt: Wähle Kleidung, die professionell und branchenangemessen ist. Im Zweifel lieber etwas formeller als zu lässig erscheinen. Achte darauf, dass die Kleidung gepflegt und sauber ist. Dein Outfit sollte Selbstbewusstsein ausstrahlen, ohne vom Gespräch abzulenken.',
  },
  {
    question: 'Wie überzeuge ich im Vorstellungsgespräch?',
    answer:
      'Um in einem Vorstellungsgespräch zu überzeugen, kommuniziere klar und ruhig, und antworte präzise und strukturiert auf Fragen. Zeige Empathie und Interesse durch aktives Zuhören und angemessene Körpersprache, wie Blickkontakt und offene Gesten. Reagiere flexibel auf unerwartete Fragen oder Situationen, um Deine Anpassungsfähigkeit und Gelassenheit unter Beweis zu stellen.',
  },
  {
    question: 'Was muss ich nach dem Vorstellungsgespräch tun?',
    answer:
      'Nach dem Vorstellungsgespräch solltest Du eine Dankes-E-Mail senden, um Höflichkeit und anhaltendes Interesse zu zeigen. Bleib geduldig, aber frage nach angemessener Zeit höflich nach, wenn Du keine Rückmeldung erhalten hast. Nutze die Wartezeit, um Deine Interviewerfahrung zu reflektieren und mögliche Verbesserungspunkte für zukünftige Gespräche zu identifizieren.',
  },
];
